import { render, staticRenderFns } from "./quartile.vue?vue&type=template&id=5c8c2762&scoped=true"
import script from "./quartile.vue?vue&type=script&lang=js"
export * from "./quartile.vue?vue&type=script&lang=js"
import style0 from "./quartile.vue?vue&type=style&index=0&id=5c8c2762&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8c2762",
  null
  
)

export default component.exports